import { isMockMode } from '@/config/env';

/** Always distinguish fixtures from production without using a tall mobile banner. */
export function MockModeBanner(): React.JSX.Element | null {
  if (!isMockMode) return null;
  return (
    <aside className="mock-mode-banner" data-testid="mock-mode-banner">
      <strong>DEV-LOCAL</strong>
      <span>Mock data · no backend · resets on reload.</span>
    </aside>
  );
}
